import api from './config';

export const getProductDetails = (slug, device_type) => {
  return api.get(`/api/products/${slug}/`, { params: { device_type, format: 'json' } });
};

export const getProductsByCategory = (category, device_type) => {
  return api.get(`/api/products/category/${category}/`, { params: { device_type, format: 'json' } });
};

export const getFeaturedProducts = (device_type) => {
  return api.get('/api/products/featured/', { params: { device_type, format: 'json' } });
};
